import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {DEVICE, Accordion, useScreenResize} from '@chekin/guestapp-ui-kit';
import arrowLeft from '../../assets/icons/arrow-left.svg?no-inline';
import Page from 'components/Page';
import Questions from './Questions';
import {BackButton, Content} from './styled';

function FAQView() {
  const {t} = useTranslation();
  const {isMatch: isDesktop} = useScreenResize(DEVICE.laptopM);
  const {isMatch: isMobile} = useScreenResize(DEVICE.laptop);
  const navigate = useNavigate();
  return (
    <Page
      isSubHeaderVisible={!isDesktop || isMobile}
      isBackButtonDisabled={isDesktop}
      navBarTitle={t('frequently_asked_questions')}
      className="fag-page"
      mainHeader={!isMobile}
    >
      <BackButton
        onClick={() => {
          navigate(-1);
        }}
        className="fag-page__back-btn w-auto"
        variant="link"
      >
        <img width={19} height={17} src={arrowLeft} alt="Arrow left" />
        {t('back')}
      </BackButton>
      <Content className="fag-page__content">
        <Accordion items={Questions()} />
      </Content>
    </Page>
  );
}

export {FAQView};
